module.exports = __webpack_public_path__ + "img/chystam-party-header-background.922a846.png";